import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Dashboard: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 3.33333H2.66665V12.6667H13.3333V3.33333ZM1.99998 2H14C14.3682 2 14.6666 2.29848 14.6666 2.66667V13.3333C14.6666 13.7015 14.3682 14 14 14H1.99998C1.63179 14 1.33331 13.7015 1.33331 13.3333V2.66667C1.33331 2.29848 1.63179 2 1.99998 2Z"
        fill={color}
      />
      <path
        d="M12.6666 4.66663H3.33331V5.99996H12.6666V4.66663Z"
        fill={color}
      />
      <path
        d="M5.33331 9.33337V7.33337C4.22875 7.33337 3.33331 8.22877 3.33331 9.33337C3.33331 10.438 4.22875 11.3334 5.33331 11.3334C6.43791 11.3334 7.33331 10.438 7.33331 9.33337H5.33331Z"
        fill={color}
      />
      <path
        d="M12.6666 7.33337H8.66663V8.66671H12.6666V7.33337Z"
        fill={color}
      />
      <path d="M12.6666 10H8.66663V11.3333H12.6666V10Z" fill={color} />
    </svg>
  );
};

export default Dashboard;
